import { SvgIconProps } from '@mui/material';
import { getAppDirection } from 'src/core/theme/getAppDirection';
import { ArrowLeft } from 'src/shared/icons/ArrowLeft';
import { ArrowRight } from 'src/shared/icons/ArrowRight';

export const ArrowNext = (props: SvgIconProps) => {
  const dir = getAppDirection();
  return dir === 'rtl' ? <ArrowLeft {...props} /> : <ArrowRight {...props} />;
};
